var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevicesMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39855 1.89293C2.39855 1.54768 2.67843 1.26781 3.02367 1.26781H18.1253C18.4705 1.26781 18.7504 1.54768 18.7504 1.89293V10.8228C18.7504 11.1681 18.4705 11.4479 18.1253 11.4479H9.12315V12.6982H10.7724L10.8034 16.7319H8.74219V17.9821H15.0286V16.7319H12.0536L12.0226 12.6982H18.1253C19.161 12.6982 20.0006 11.8585 20.0006 10.8228V1.89293C20.0006 0.857201 19.161 0.0175781 18.1253 0.0175781H3.02367C1.98794 0.0175781 1.14832 0.8572 1.14832 1.89293V4.72496H2.39855V1.89293ZM1.25023 16.5837V7.65381L6.29352 7.65381L6.29352 16.5837H1.25023ZM0 16.5837V7.65381C0 6.96333 0.559747 6.40358 1.25023 6.40358H6.29352C6.98401 6.40358 7.54376 6.96333 7.54376 7.65381V16.5837C7.54376 17.2742 6.98401 17.8339 6.29352 17.8339H1.25023C0.559748 17.8339 0 17.2742 0 16.5837Z",
    fill: "#878A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesMedium);
export default __webpack_public_path__ + "static/media/devices-medium.970d581b40ccfe0aa3e3625631b08dd7.svg";
export { ForwardRef as ReactComponent };